<page-context [page]="this">
  <div class="my-profile" *ngIf="user && !user.profile">
    <em>Error: An issue with your account prevents you from editing your profile. Please contact support@tytnetwork.com and paste the following information in your email:</em>
    <br/><br/>

    <pre>
      engn-escalate:profile.upm
      account: {{user.uuid}}</pre>
  </div>

  <div class="my-profile" *ngIf="user && user.profile">
    <div class="notice">
      <app-notice></app-notice>
    </div>

    <div>
      <tyt-photo-uploader 
        *ngIf="coverStep === 'default'"
        [user]="user"
        [aspectRatio]="1 / 1"
        [resizeToWidth]="600"
        [currentImage]="user.profile.avatar"
        [showCircularPreviews]="true"
        (saved)="saveAvatar($event)"
        (stepChanged)="avatarStep = $event"
        label="Upload your Profile Picture"
        guidance="Photo should be at least 600px x 600px"
        ></tyt-photo-uploader>
    </div>
    
    <tyt-photo-uploader 
      *ngIf="avatarStep === 'default'"
      [user]="user"
      [aspectRatio]="1941 / 281"
      [resizeToWidth]="1941"
      [currentImage]="user.profile.cover_photo"
      (stepChanged)="coverStep = $event"
      (saved)="saveCover($event)"
      label="Upload your Cover Photo"
      guidance="Photo should be at least 1200px x 600px"
      ></tyt-photo-uploader>

    <app-form *ngIf="avatarStep === 'default' && coverStep === 'default'" action="/settings/profile" [handler]="this" class="form-fields">
      <div class="form-group text-field full-width">
        <label for="displayName">Display Name</label>
        <input 
          errorHighlight 
          type="text" 
          class="form-control" 
          id="display-name" 
          name="displayName" 
          [(ngModel)]="displayName" 
          required />
        <tyt-privacy-status state="public"></tyt-privacy-status>
        <em>What should we call you? This name will be shown with your avatar on your public profile page as well as
          when you chat and post comments. It does not have to be your real name!</em>
      </div>

      <div class="form-container">
        <div class="form-group text-field">
          <label for="firstName">First Name</label>
          <input 
            errorHighlight 
            type="text" 
            class="form-control" 
            id="first-name" 
            name="firstName" 
            [(ngModel)]="firstName" 
            required />
          <tyt-privacy-status state="private"></tyt-privacy-status>
        </div>
        
        <div class="form-group text-field">
          <label for="lastName">Last Name</label>
          <input 
            errorHighlight 
            type="text" 
            class="form-control" 
            id="last-name" 
            name="lastName" 
            [(ngModel)]="lastName" 
            required />
            <tyt-privacy-status state="private"></tyt-privacy-status>
        </div>

        <div class="form-group birthdate-container">
          <label>Birthdate</label>
          <div class="birthdate">
            <div class="month">
              <input 
                errorHighlight 
                maxlength="2" 
                placeholder="MM" 
                type="text" 
                class="form-control" 
                id="month" 
                name="month" [(ngModel)]="month" 
                required />
            </div>
            <div class="day">
              <input 
                errorHighlight 
                maxlength="2" 
                placeholder="DD" 
                type="text" 
                class="form-control" 
                id="day" 
                name="day" 
                [(ngModel)]="day" 
                required />
            </div>
            <div class="year">
              <input 
                errorHighlight 
                maxlength="4" 
                placeholder="YYYY" 
                type="text" 
                class="form-control" 
                id="year" 
                name="year" 
                [(ngModel)]="year" 
                required />
            </div>
          </div>
          <tyt-privacy-status state="private"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="inspirational-figure">Education</label>
          <select class="form-control" id="college" name="college" [(ngModel)]="metadata.college">
            <option disabled selected value>Select One</option>
            <option value="primary-school">Primary / Elementary</option>
            <option value="secondary-school">Secondary / Middle</option>
            <option value="high-school">High School</option>
            <option value="bachelors">College (Bachelors)</option>
            <option value="masters">College (Masters)</option>
            <option value="doctorate">College (Doctorate)</option>
            <option value="">Prefer not to say</option>
          </select>
          <tyt-privacy-status state="private"></tyt-privacy-status>
        </div>

        <h1>About Me</h1>

        <div class="public-profile" *ngIf="!username">
          <em>You don't have a username yet, you can set it by clicking here: </em>
          <a class="btn-2 btn-compact" routerLink="/settings/account/change-username">Set my username</a>
        </div>

        <div class="public-profile" *ngIf="username !== null">
          <a class="btn-2 btn-compact" routerLink="/community/profile/{{username}}" target="_blank">View Public Profile</a>
        </div>

        <div class="form-group full-width">
          <label for="disable-public" title="Choose this option if you wish to opt out of having a public profile on TYT.com">
            <input
              type="checkbox"
              class="disable-public"
              id="disable-public"
              name="disablePublic"
              [(ngModel)]="disablePublic"
              />
            
            Disable my public profile
          </label>
        </div>

        <div class="form-group text-field full-width">
          <label for="about-me">About Me</label>
          <textarea 
            class="form-control" 
            rows="4" 
            id="about-me" 
            name="about-me" 
            [(ngModel)]="aboutMe"
            ></textarea>
            <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="tagline">Tagline</label>
          <input 
            errorHighlight 
            type="text" 
            class="form-control" 
            id="tagline" 
            name="tagline" 
            [(ngModel)]="tagline" 
            required />
            <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="inspirational-figure">Favorite Inspirational Figure</label>
          <input 
            errorHighlight 
            type="text" 
            class="form-control" 
            id="inspirational-figure" 
            name="inspirational-figure" 
            [(ngModel)]="favoriteInspirationalFigure" 
            required />
            <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="favorite-quote">Favorite Quote</label>
          <input 
            errorHighlight 
            type="text" 
            class="form-control" 
            id="favorite-quote" 
            name="favorite-quote" 
            [(ngModel)]="favoriteQuote" 
            required />
            <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="favorite-tyt-memory">Favorite TYT Memory</label>
          <input 
            errorHighlight 
            type="text" 
            class="form-control" 
            id="favorite-tyt-memory" 
            name="favorite-tyt-memory" 
            [(ngModel)]="favoriteTYTMemory" 
            required />
            <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="political-views">Political Views</label>
          <input 
            errorHighlight 
            type="text" 
            class="form-control" 
            id="political-views" 
            name="political-views" 
            [(ngModel)]="politicalViews" 
            required />
            <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="religion-philosophy">Religion / Philosophy</label>
          <input 
            errorHighlight 
            type="text" 
            class="form-control" 
            id="religion-philosophy" 
            name="religion-philosophy" 
            [(ngModel)]="religionOrPhilosophy" 
            required />
            <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
    
        <div class="form-group text-field">
          <label for="gender">Gender</label>
          <select class="form-control" id="gender" name="gender" [(ngModel)]="gender">
            <option disabled selected value>Select One</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="non-binary">Non-Binary</option>
            <option value="prefer not to say">Prefer not to say</option>
          </select>
          <tyt-privacy-status state="private"></tyt-privacy-status>
        </div>

        <div class="form-group pronouns">
          <label>Pronouns</label>
          <label *ngFor="let pronoun of pronouns">
            <input type="checkbox" [(ngModel)]="pronoun.selected">  
            {{ pronoun.label }}
          </label>
          <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>

      </div>

      <h1>Location</h1>

      <div class="form-container">

        <div class="form-group text-field city">
          <label for="city">City</label>
          <input errorHighlight placeholder="e.g. Los Angeles" type="text" class="form-control" id="city" name="city" [(ngModel)]="city" required>
          <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="state">State / Province</label>
          <input errorHighlight maxlength="2" placeholder="e.g. CA" type="text" class="form-control" 
          id="state" name="state" [(ngModel)]="state" required>
          <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="country">Country</label>
          <select name="country" id="country" [(ngModel)]="country">
            <ng-container *ngIf="countries"?>
              <option [value]="country.code" *ngFor="let country of countries">
                {{country.name}}
              </option>
            </ng-container>
          </select>
          <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>
        <div class="form-group text-field">
          <label for="zip">Postal Code</label>
          <input errorHighlight 
            maxlength="20" 
            type="text" 
            class="form-control" 
            id="zip" 
            name="zip" 
            [(ngModel)]="zip" 
            required />
            <tyt-privacy-status state="private"></tyt-privacy-status>
        </div>
      </div>

      <h1>Social</h1> 

      <div class="form-container">

        <div class="form-group text-field">
          <label for="facebookUrl">Facebook URL</label>
          <input errorHighlight type="text" class="form-control" id="facebook-url" name="facebookUrl" [(ngModel)]="facebookUrl" required>
          <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>

        <div class="form-group text-field">
          <label for="twitterHandle">Twitter Handle</label>
          <input errorHighlight type="text" class="form-control" id="twitter-handle" name="twitterHandle" [(ngModel)]="twitterHandle" required>
          <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>

        <div class="form-group text-field">
          <label for="instagramHandle">Instagram Handle</label>
          <input errorHighlight type="text" class="form-control" id="instagram-handle" name="instagramHandle" [(ngModel)]="instagramHandle" required>
          <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>

        <div class="form-group text-field">
          <label for="linkedinHandle">Linkedin URL</label>
          <input errorHighlight type="text" class="form-control" id="linkedin-handle" name="linkedinHandle" [(ngModel)]="linkedinHandle" required>
          <tyt-privacy-status state="public"></tyt-privacy-status>
        </div>

      </div>
      
      <div class="actions">
        <a class="btn-2 btn-compact btn-cancel" href="javascript:;" (click)="cancelEdit()">Cancel</a>
        <button class="btn-2 btn-compact">Save</button>
        <!-- <app-form-submit-button>Submit</app-form-submit-button> -->
      </div>

      <error-message [host]="this"></error-message>

      <div *ngIf="updateSuccessMessage" class="alert alert-success updateSuccessMessage">
        {{updateSuccessMessage}}
      </div>

    </app-form>
  </div>
</page-context>